export const DEFAULT_MAX_SOURCES = 4;
